import styled from 'styled-components';

/* Mixins */
import { WebFontBody1, WebFontBody2 } from 'styles/Mixins';

/* Utils */
import { assignIfDefined } from 'styles/Utils';

export const ColumnWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  margin-left: 8px;
`;

export const ContentWrapper = styled.div`
  margin-top: 2px;
  width: 100%;
  ${WebFontBody2};
  color: ${({ theme }) => theme.Grey1};
  line-height: 24px;
  text-align: left;
`;

export const Title = styled.div`
  ${WebFontBody1};
  text-align: initial;
  color: ${({ theme }) => theme.Grey1};
`;

export const TextBox = styled.div<{ margin?: string }>`
  display: flex;
  border-radius: 4px;
  align-items: center;
  padding: 10px;
  box-sizing: border-box;
  ${({ theme }) => `
    background: ${theme.Grey7};
    border: 0.6px solid ${theme.Grey8}
  `};
  ${assignIfDefined('margin')};
`;
